import { HowToCreateSteps } from '@components/how-to-create-steps/how-to-create-steps';

export const HowToCreateInfoWidget = () => <HowToCreateSteps />;
